'use client';

import { useRouter } from 'next/navigation';

import { Container, Subtitle } from './not-found.elements';
import { Title } from '@/styles/global.elements';
import { Button } from '@/elements/button/button.component';

const NotFound = () => {
  const router = useRouter();

  return (
    <Container>
      <Title>Hmmm, ovdje nema sadržaja.</Title>
      <Subtitle>Provjeri poveznicu koja te dovela ovdje. Možda ima grešku.</Subtitle>
      <Button alignSelf="center" onClick={() => router.back()}>
        Vrati se
      </Button>
    </Container>
  );
};

export { NotFound };
